import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-tools-axe-icon',
  templateUrl: './tools-axe.component.html'
})
export class ToolsAxeComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
